import clsx from 'clsx'
import { Typography } from 'components/common'
import { t } from 'i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import styles from './ViewBlocker.module.scss'
import Button from '../../../../common/Button/Button'

interface Props {
  breakpoint: 'desktop' | 'tab-port' | 'tab-land' | 'phone'
  children?: React.ReactNode
}

const responsiveRoutes = [
  '/',
  '/favorites',
  '/overview',
  '/search',
  '/user/onboard',
  '/sso',
  '/login',
  '/connect/qibri',
  '/new-guideline',
  { path: '/practices', strict: false },
  { path: '/materials', strict: false },
  { path: '/documents', strict: false },
  { path: '/front-office', strict: false },
]

const ViewBlocker = ({ breakpoint, children }: Props) => {
  const navigate = useNavigate()
  const classes = clsx(styles.root, styles[`bp-${breakpoint}`])
  const location = useLocation()

  const handleClick = (currentPath: string, isGuidelineOrDocument: boolean) => {
    navigate({
      pathname: isGuidelineOrDocument
        ? currentPath.replace('back-office', 'front-office')
        : '/',
    })
  }

  if (matchRoute(responsiveRoutes, location.pathname)) {
    return null
  }

  const isGuidelineOrDocument = location.pathname !== '/practices'

  return (
    <div className={classes}>
      {children ? (
        children
      ) : (
        <>
          <Typography
            type="display"
            fontWeight="bold"
            size="small"
            element="h1"
            className={styles.header}
          >
            {isGuidelineOrDocument
              ? t('viewBlock.title')
              : t('viewBlock.overview')}
          </Typography>
          {isGuidelineOrDocument && (
            <Button
              onClick={() =>
                handleClick(location.pathname, isGuidelineOrDocument)
              }
            >
              {t('viewBlock.goto')}
            </Button>
          )}
          {!isGuidelineOrDocument && (
            <Button
              onClick={() =>
                handleClick(location.pathname, isGuidelineOrDocument)
              }
            >
              {t('viewBlock.gotoHome')}
            </Button>
          )}
        </>
      )}
    </div>
  )
}

const matchRoute = (routes: typeof responsiveRoutes, currentPath: string) => {
  return !!routes.find((route) => {
    if (typeof route === 'string') {
      return route === currentPath
    }

    if (route.strict) {
      return route.path === currentPath
    }

    return currentPath.includes(route.path)
  })
}

export default ViewBlocker
